module.exports = __webpack_public_path__ + "static/media/death.e25778e6.png";